import angular from 'angular';

import directive from './report-instances.directive';
import controller from './report-instances.controller';

import reportInstance from './reportInstance';

export default angular.module('app.components.reports.myReports.reportType.reportInstances', [
  reportInstance
])
  .directive('mrReportInstances', directive)
  .controller('MRReportInstancesController', controller)
  .name;

console.log('app.components.reports.myReports.reportType.reportInstances created');
